import axios from 'axios';
import {useFormik } from 'formik';
import React, { useContext } from 'react';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import step1 from '../../src/Assets/images/1.gif'


export default function ForgetPassword() {
   const [errorMsg, seterrorMsg] = useState()
   const [isloading , setisloading] = useState()

   const navigate = useNavigate()
     const validationSchema = yup.object({
      email : yup.string().required("Email Field is required").matches(/^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/i , "Enter Valid Email"),
    
     })
  


  const {values , handleSubmit , handleChange ,errors , touched , handleBlur , isValid}= useFormik({
      initialValues:{
        email :'',
      },
      onSubmit : async ()=>{
       try {
        setisloading(true)
        let response = await axios.post('https://ecommerce.routemisr.com/api/v1/auth/forgotPasswords',values)
        console.log(response.data.statusMsg)
        if(response.data.statusMsg=="success"){
        
            navigate('/verify-code')

          
        }
       } catch (error) {
        seterrorMsg(error.response.data.message)

       }
       setisloading(false)
      },

      validationSchema
     })

  return <>
   <div className="container">
   <div className='AuthDiv'>
    
    <div className="w-75 m-auto my-5 authoinner p-xl-5 p-3">
     <div className="row align-items-center">
       <div className="col-md-6">
       <h3>Please enter your Email :</h3>
       <form onSubmit={handleSubmit}>
         
        <label htmlFor="email" className='my-1'>Email:</label>
         <input onChange={handleChange} value={values.email} type="email" className='form-control mb-3' id='email' name='email' />
         {errors.email && touched.email &&  <p className='alert alert-danger'>{errors.email}</p>}       
 
    
      
        {errorMsg && <div className=" alert alert-danger">{errorMsg}</div>}
        {         isloading ? <button disabled type='button' className='btn bg-main px-3 text-white ms-auto d-block px-3'> <i className='fas fa-spin fa-spinner px-4'></i> </button>
                   :
                   <button type='submit' disabled ={ isloading} className='btn bg-main px-3 text-white ms-auto d-block'>Verfiy</button>
       }
 
       </form>
       </div>
       <div className="col-md-6">
       <img src={step1} className='w-100'/>
       </div>
     </div>
     </div>
    </div>
   </div>
  </>
}
